import Api from '../Api.js';
import BaseView from './_BaseView.js';
import Confirm from '../components/Confirm.js';
import Dropdown from '../components/Dropdown.js';
import Table from '../components/Table.js';
import trans from "../util/trans";

export default class BlacklistView extends BaseView {
    constructor() {
        super();
        this.formSelector = '#blacklistForm';
        this.formUrl = '/api/blacklist';
        this.formTpl = 'blacklist-form';
        this.formTitle = 'Blacklist Information';
        this.defaultObject = {
            title: '',
            desc: '',
        };
        this.formCallback = function () {
            this.table.reload();
        };
    }

    init() {
        super.init();
        const self = this;

        if ($('#blacklist').length > 0) {
            this.table = new Table('blacklist', '/api/blacklist/table', [
                {data: 'select', orderable: false},
                {data: 'url'},
                {data: 'description'},
                {data: 'globPrefix'},
                {data: 'globSuffix'},
                {data: 'tools', orderable: false},
            ]);

            this.menu = new Dropdown('#blacklistPageMenu', {
                onDelete: function (ids) {
                    if (ids.length > 0) {
                        Confirm({
                            ok: Lang.delete,
                            title: Lang.deleting,
                            msg: trans('deletex', ids.length),
                            onConfirm: function () {
                                // Blacklist.api.del(ids);
                                // TODO: delete multiple intead of loop below
                                $.each(ids, function (i, row) {
                                    Api.send(`/api/blacklist/${row}`, {}, 'delete').done(function () {
                                        self.table.reload();
                                    });
                                });

                            }
                        });
                    }
                }
            });
        }
    }

    getFormData() {
        const data = super.getFormData();
        data.globPrefix = !!(data.globPrefix);
        data.globSuffix = !!(data.globSuffix);
        return data;
    }

    setEvents() {
        super.setEvents();
        const self = this;
        const section = $('#blacklistGroup');

        //Add
        section.parents('main').find('.add').off("click.blackista").on("click.blackista", function () {
            self.renderForm();
            return false;
        });

        //Delete
        section.off("click.blackistd").on("click.blackistd", ".delete", function () {
            const id = $(this).parents('div:eq(0)').data('id');
            const name = $(this).parents('tr').find('td:eq(1)').text();

            Confirm({
                ok: Lang.delete,
                title: name,
                msg: Lang.delsure,
                onConfirm: function () {
                    Api.send(`/api/blacklist/${id}`, {}, 'delete').done(function () {
                        self.table.reload();
                    });
                }
            });

            return false;
        });

        //Edit
        section.off("click.blackiste").on("click.blackiste", ".edit", function () {
            const id = $(this).parents('div:eq(0)').data('id');

            Api.send(`/api/blacklist/${id}`).done(function (r) {
                self.renderForm(r);
            });
            return false;
        });

        //Find Preview
        section.off("click.grepl").on("click.grepl", ".aero-btn-fpreview", function () {
            if ($('#findReplaceForm').isFormValid()) {
                // Blacklist.model.replaceProp($(this).parents('form').data('ids'), true);
                // TODO: Find preview?
            }
        });
    }
}